module.exports = __webpack_public_path__ + "static/media/Banner_latam_pass_420x150.50e6a0d0.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/Banner_latam_pass_420x150.png
// module id = 1946
// module chunks = 14